export default {
  title: {
    type: 'string',
    default: '',
  },
  titleTag: {
    type: 'string',
    default: 'h2',
  },
  subtitle: {
    type: 'string',
    default: '',
  },
  variant: {
    type: 'string',
    default: 'default',
  },
  padded: {
    type: 'boolean',
    default: true,
  },
  isParent: {
    type: 'boolean',
    default: true,
  },
  containerized: {
    type: 'boolean',
    default: false,
  },
  color: {
    type: 'string',
    default: 'borderBlack',
  },
  textColor: {
    type: 'string',
    default: 'textGrey',
  },
  hasMargin: {
    type: 'boolean',
    default: true,
  },
  border: {
    type: 'boolean',
    default: true,
  },
  hasId: {
    type: 'boolean',
    default: false,
  },
  idAccordion: {
    type: 'string',
    default: '',
  },
};
